export const contactInfo = {
  phone: '09 86 78 69 84',
  email: 'groupendv@gmail.com',
  comptaEmail: 'compta.groupendv@gmail.com',
  address: '13 RUE DES METIERS',
  city: '57970 Yutz',
  instagram: '@groupe_ndv',
  instagramUrl: 'https://www.instagram.com/groupe_ndv/',
  hours: {
    weekdays: 'Lundi - Vendredi : 8h-12h et 13h-18h',
    saturday: 'Samedi : 8h-13h',
    sunday: 'Dimanche : Fermé'
  }
};

export const services = [
  {
    id: 1,
    title: 'Achat Vente REPRISE',
    description: 'Achat et vente de véhicules toutes marques. Reprise de votre ancien véhicule au meilleur prix. Conseil personnalisé pour l\'achat de votre prochain véhicule.',
    icon: 'ShoppingCart',
    image: 'https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/fj73eqg5_4aa60a869044c0e9cbddfc168ac82a52.jpg'
  },
  {
    id: 2,
    title: 'Mécanique Auto Générale',
    description: 'Entretien complet de votre véhicule : vidange, distribution, freinage, embrayage, échappement. Diagnostic et réparation toutes marques.',
    icon: 'Wrench',
    image: 'https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/hmdgy3mn_istockphoto-1347150429-612x612.jpg'
  },
  {
    id: 3,
    title: 'Carrosserie Automobile',
    description: 'Réparation complète de carrosserie et peinture professionnelle. Débosselage, redressage, peinture en cabine. Travail de précision pour un résultat impeccable.',
    icon: 'Paintbrush',
    image: 'https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/ffornf8s_peinture-carrosserie-le-beausset-garage-peugeot-azur-autos.webp'
  },
  {
    id: 4,
    title: 'Rénovation de Jantes Alu de A à Z',
    description: 'Rénovation complète de vos jantes aluminium : ponçage, redressage, peinture, polissage. Redonnez l\'éclat d\'origine à vos jantes.',
    icon: 'CircleDot',
    image: 'https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/6g2j3vem_poncer-jante-alu.jpg'
  },
  {
    id: 5,
    title: 'Pneumatique',
    description: 'Vente et montage de pneus toutes marques. Équilibrage, géométrie, permutation. Conseil personnalisé pour le choix de vos pneumatiques.',
    icon: 'Disc',
    image: 'https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/jjujvd5v_000258017_600x400_c.jpg'
  },
  {
    id: 6,
    title: 'Detailing',
    description: 'Nettoyage intérieur et extérieur premium. Polissage, lustrage, traitement céramique, rénovation optiques. Service esthétique haut de gamme.',
    icon: 'Sparkles',
    image: 'https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxjYXIlMjBkZXRhaWxpbmd8ZW58MHx8fHwxNzY5MTc4NzA2fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 7,
    title: 'Diagnostic',
    description: 'Diagnostic électronique complet de votre véhicule. Détection de pannes, lecture et effacement des codes défauts. Valise diagnostic professionnelle.',
    icon: 'Search',
    image: 'https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/25spmrdv_diagnostic-auto-opt-scaled.jpg'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Marc L.',
    rating: 5,
    text: 'Travail impeccable sur ma BMW après un accident. L\'équipe de NDV Motors est très professionnelle, délais respectés et finitions parfaites. Je recommande vivement !',
    date: 'Mars 2025'
  },
  {
    id: 2,
    name: 'Sophie D.',
    rating: 5,
    text: 'Excellente prestation pour la rénovation de ma Mercedes. La peinture est parfaite, on ne voit aucune différence avec l\'origine. Vraiment du travail de qualité !',
    date: 'Février 2025'
  },
  {
    id: 3,
    name: 'Thomas R.',
    rating: 5,
    text: 'J\'ai fait monter des jantes sur mon Audi. Conseil au top, large choix et montage pro. Le rendu est magnifique, exactement ce que je voulais.',
    date: 'Janvier 2025'
  },
  {
    id: 4,
    name: 'Julie M.',
    rating: 5,
    text: 'Après un accrochage, ma voiture a retrouvé son état d\'origine grâce à NDV Motors. Travail soigné, accueil chaleureux et tarifs honnêtes.',
    date: 'Décembre 2024'
  }
];

export const galleryImages = [
  {
    id: 1,
    title: 'Garage NDV Motors - Vue extérieure',
    category: 'garage',
    image: 'https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/ucympth3_WhatsApp%20Image%202024-09-03%20%C3%A0%2013.12.48_639d0365.jpg'
  },
  {
    id: 2,
    title: 'Garage NDV Motors - Entrée principale',
    category: 'garage',
    image: 'https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/yxy0zjcb_WhatsApp%20Image%202024-09-06%20%C3%A0%2008.23.30_62fb9842.jpg'
  },
  {
    id: 3,
    title: 'Showroom Jantes - Collection Premium',
    category: 'jantes',
    image: 'https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/fx3iqcqm_4acf64880a571d27dd95d92d05edeb815a9085b1.jpg'
  },
  {
    id: 4,
    title: 'Jantes Haut de Gamme - Large Sélection',
    category: 'jantes',
    image: 'https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/03wtpgkf_5110277575dc7e57306bee02597dc68808b7b15e.jpg'
  },
  {
    id: 5,
    title: 'Détailing Luxury - Finitions Premium',
    category: 'renovation',
    image: 'https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxjYXIlMjBkZXRhaWxpbmd8ZW58MHx8fHwxNzY5MTc4NzA2fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 6,
    title: 'Carrosserie - Travail de Précision',
    category: 'carrosserie',
    image: 'https://images.unsplash.com/photo-1620584899131-a5ff5f8fbb03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxjYXIlMjBkZXRhaWxpbmd8ZW58MHx8fHwxNzY5MTc4NzA2fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 7,
    title: 'Peinture Automobile - Cabine Pro',
    category: 'peinture',
    image: 'https://images.unsplash.com/photo-1694025893767-9a212606fbc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjYXIlMjBnYXJhZ2V8ZW58MHx8fHwxNzY5MTc4Njk1fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 8,
    title: 'Véhicules Premium - Expertise Haut de Gamme',
    category: 'realisations',
    image: 'https://images.unsplash.com/photo-1694025881942-b752102cee95?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXIlMjBnYXJhZ2V8ZW58MHx8fHwxNzY5MTc4Njk1fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 9,
    title: 'Réparation Luxury - Qualité Premium',
    category: 'realisations',
    image: 'https://images.unsplash.com/photo-1544218159-ee555140c5b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBjYXIlMjBnYXJhZ2V8ZW58MHx8fHwxNzY5MTc4Njk1fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 10,
    title: 'Excellence Automobile - Travail Soigné',
    category: 'realisations',
    image: 'https://images.pexels.com/photos/30687969/pexels-photo-30687969.jpeg'
  },
  {
    id: 11,
    title: 'Finitions Professionnelles',
    category: 'renovation',
    image: 'https://images.pexels.com/photos/29504461/pexels-photo-29504461.jpeg'
  },
  {
    id: 12,
    title: 'Expertise NDV Motors',
    category: 'carrosserie',
    image: 'https://images.pexels.com/photos/20051462/pexels-photo-20051462.jpeg'
  }
];

export const stats = [
  {
    id: 1,
    number: '30+',
    label: 'Véhicules réparés par semaine'
  },
  {
    id: 2,
    number: '15',
    label: 'Véhicules de prêt A, B, C'
  },
  {
    id: 3,
    number: '5',
    label: 'Années d\'expérience'
  },
  {
    id: 4,
    number: '7',
    label: 'Services spécialisés'
  }
];

export const insurancePartners = [
  {
    id: 1,
    name: 'AXA',
    logo: 'https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/6jrffx5w_Axa-logo.png'
  },
  {
    id: 2,
    name: 'Allianz',
    logo: 'https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/ywxfxv5p_Allianz.svg.png'
  },
  {
    id: 3,
    name: 'Macif',
    logo: 'https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/azriypfb_th-320x240-logo_macif_liseret_blanc_rvb.jpg.jpg'
  },
  {
    id: 4,
    name: 'L\'Olivier Assurance',
    logo: 'https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/u9dsdbba_lolivier.webp'
  },
  {
    id: 5,
    name: 'GAN Assurances',
    logo: 'https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/d7ff2pnt_6220f6495c53170be44b5152.png'
  },
  {
    id: 6,
    name: 'Groupama',
    logo: 'https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/3s6coo81_62432ca1728ee72abb6d0f72.png'
  },
  {
    id: 7,
    name: 'Et bien d\'autres...',
    logo: null,
    isPlaceholder: true
  }
];

export const detailedServices = [
  {
    id: 'carrosserie',
    title: '🛠️ CARROSSERIE',
    icon: 'Wrench',
    items: [
      { id: 'diag_carrosserie', label: 'Diagnostic carrosserie' },
      { id: 'debosselage_simple', label: 'Débosselage simple' },
      { id: 'debosselage_peinture', label: 'Débosselage avec peinture' },
      { id: 'debosselage_dsp', label: 'Débosselage sans peinture (DSP)' },
      { id: 'redressage_tole', label: 'Redressage de tôle' },
      { id: 'reparation_aile', label: 'Réparation aile' },
      { id: 'reparation_porte', label: 'Réparation porte' },
      { id: 'reparation_parechocs_av', label: 'Réparation pare-chocs avant' },
      { id: 'reparation_parechocs_ar', label: 'Réparation pare-chocs arrière' },
      { id: 'reparation_capot', label: 'Réparation capot' },
      { id: 'reparation_coffre', label: 'Réparation coffre / hayon' },
      { id: 'reparation_bas_caisse', label: 'Réparation bas de caisse' },
      { id: 'remplacement_element', label: 'Remplacement élément carrosserie' },
      { id: 'ajustement_jeux', label: 'Ajustement des jeux et alignements' },
      { id: 'remise_etat_leger', label: 'Remise en état après choc léger' },
      { id: 'remise_etat_important', label: 'Remise en état après choc important' }
    ]
  },
  {
    id: 'peinture',
    title: '🎨 PEINTURE AUTOMOBILE',
    icon: 'Paintbrush',
    items: [
      { id: 'peinture_element', label: 'Peinture élément seul' },
      { id: 'peinture_parechocs', label: 'Peinture pare-chocs' },
      { id: 'peinture_aile', label: 'Peinture aile' },
      { id: 'peinture_porte', label: 'Peinture porte' },
      { id: 'peinture_capot', label: 'Peinture capot' },
      { id: 'peinture_coffre', label: 'Peinture coffre / hayon' },
      { id: 'peinture_complete', label: 'Peinture complète véhicule' },
      { id: 'peinture_partielle', label: 'Peinture partielle' },
      { id: 'raccord_peinture', label: 'Raccord peinture' },
      { id: 'retouches_peinture', label: 'Retouches peinture' },
      { id: 'peinture_vernie', label: 'Peinture vernie' },
      { id: 'peinture_mate', label: 'Peinture mate' },
      { id: 'peinture_nacree', label: 'Peinture nacrée / métallisée' },
      { id: 'changement_couleur', label: 'Changement de couleur' },
      { id: 'traitement_rayures', label: 'Traitement anti-rayures' },
      { id: 'traitement_uv', label: 'Traitement anti-UV' }
    ]
  },
  {
    id: 'jantes',
    title: '🚗 JANTES & PNEUS',
    icon: 'CircleDot',
    items: [
      { id: 'vente_jantes', label: 'Vente de jantes' },
      { id: 'conseil_jantes', label: 'Conseil choix jantes' },
      { id: 'montage_jantes', label: 'Montage jantes' },
      { id: 'equilibrage', label: 'Équilibrage' },
      { id: 'changement_pneus', label: 'Changement pneus' },
      { id: 'reparation_jante', label: 'Réparation jante' },
      { id: 'redressage_jante', label: 'Redressage jante' },
      { id: 'peinture_jantes', label: 'Peinture jantes' },
      { id: 'renovation_jantes', label: 'Rénovation jantes' },
      { id: 'nettoyage_jantes', label: 'Nettoyage jantes premium' }
    ]
  },
  {
    id: 'mecanique',
    title: '🔧 MÉCANIQUE LÉGÈRE',
    icon: 'Settings',
    items: [
      { id: 'diag_mecanique', label: 'Diagnostic mécanique' },
      { id: 'vidange', label: 'Vidange moteur' },
      { id: 'remplacement_filtres', label: 'Remplacement filtres' },
      { id: 'remplacement_plaquettes', label: 'Remplacement plaquettes de frein' },
      { id: 'remplacement_disques', label: 'Remplacement disques de frein' },
      { id: 'remplacement_batterie', label: 'Remplacement batterie' },
      { id: 'changement_amortisseurs', label: 'Changement amortisseurs' },
      { id: 'changement_echappement', label: 'Changement échappement' },
      { id: 'changement_embrayage', label: 'Changement embrayage' }
    ]
  },
  {
    id: 'esthetique',
    title: '🧽 ESTHÉTIQUE & FINITIONS',
    icon: 'Sparkles',
    items: [
      { id: 'nettoyage_interieur', label: 'Nettoyage intérieur' },
      { id: 'nettoyage_exterieur', label: 'Nettoyage extérieur' },
      { id: 'nettoyage_complet', label: 'Nettoyage complet (intérieur + extérieur)' },
      { id: 'lustrage', label: 'Lustrage carrosserie' },
      { id: 'polissage', label: 'Polissage' },
      { id: 'renovation_optiques', label: 'Rénovation optiques de phares' },
      { id: 'traitement_ceramique', label: 'Traitement céramique' },
      { id: 'protection_carrosserie', label: 'Protection carrosserie' },
      { id: 'detailing_complet', label: 'Détailing complet' }
    ]
  },
  {
    id: 'assurance',
    title: '🚘 SERVICES ASSURANCE & SINISTRE',
    icon: 'ShieldCheck',
    items: [
      { id: 'devis_assurance', label: 'Devis assurance' },
      { id: 'reparation_sinistre', label: 'Réparation suite sinistre' },
      { id: 'prise_charge_assurance', label: 'Prise en charge assurance' },
      { id: 'dossier_assurance', label: 'Dossier assurance clé en main' },
      { id: 'vehicule_non_responsable', label: 'Véhicule non responsable' },
      { id: 'expertise_vehicule', label: 'Expertise véhicule' }
    ]
  },
  {
    id: 'complementaires',
    title: '📄 SERVICES COMPLÉMENTAIRES',
    icon: 'FileText',
    items: [
      { id: 'devis_gratuit', label: 'Devis gratuit' },
      { id: 'conseil_perso', label: 'Conseil personnalisé' },
      { id: 'controle_avant_vente', label: 'Contrôle avant vente' },
      { id: 'preparation_vente', label: 'Préparation véhicule avant vente' },
      { id: 'preparation_leasing', label: 'Préparation véhicule leasing / restitution' },
      { id: 'pret_vehicule', label: 'Prêt de véhicule' }
    ]
  },
  {
    id: 'informations',
    title: '📝 INFORMATIONS CLIENT',
    icon: 'Info',
    items: [
      { id: 'vehicule_immobilise', label: 'Véhicule immobilisé' },
      { id: 'vehicule_roulant', label: 'Véhicule roulant' },
      { id: 'intervention_urgente', label: 'Intervention urgente' },
      { id: 'intervention_rdv', label: 'Intervention sur rendez-vous' }
    ]
  }
];
